module.exports = __webpack_public_path__ + "img/vertical_4_4_8003.a339ff17.png";